import React, { useState, useEffect } from "react";

const SettingsModal = ({ onClose, onFloorChange }) => {
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("settings");

  const [defaultFloor, setDefaultFloor] = useState(
    localStorage.getItem('defaultFloor') || 'inside'
  );

  const handleFloorChange = (floor) => {
    setDefaultFloor(floor);
    localStorage.setItem('defaultFloor', floor);
    onFloorChange?.(floor); // pozovi prop ako postoji (za desktop)
  };

  useEffect(() => {
    if (activeTab === "logs") {
      setLogsLoading(true);
      fetch("/reservations/api/logs/")
        .then(res => res.json())
        .then(data => {
          setLogs(data.logs || []);
          setLogsLoading(false);
        })
        .catch(() => setLogsLoading(false));
    }
  }, [activeTab]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-gray-900 border border-[#c1b428] rounded-xl shadow-2xl w-[500px] max-h-[80vh] flex flex-col">
        
        {/* Header */}
        <div className="p-4 border-b border-[#c1b428] flex justify-between items-center">
          <h2 className="text-base font-bold text-[#c1b428]">⚙️ Postavke</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-xl">✕</button>
        </div>

        {/* Tabovi */}
        <div className="flex border-b border-gray-700">
          <button
            onClick={() => setActiveTab("settings")}
            className={`flex-1 py-2 text-xs font-semibold ${
              activeTab === "settings" ? "text-[#c1b428] border-b-2 border-[#c1b428]" : "text-gray-400"
            }`}
          >
            Postavke
          </button>
          <button
            onClick={() => setActiveTab("logs")}
            className={`flex-1 py-2 text-xs font-semibold ${
              activeTab === "logs" ? "text-[#c1b428] border-b-2 border-[#c1b428]" : "text-gray-400"
            }`}
          >
            Logovi aktivnosti
          </button>
        </div>

        <div className="overflow-y-auto flex-1 p-4">
          
          {activeTab === "settings" && (
            <div className="space-y-4">
              
              {/* Defaultni prikaz */}
              <div className="bg-gray-800 rounded-lg p-3">
                <h3 className="text-[#c1b428] text-xs font-semibold mb-2">Defaultni prikaz tlocrta</h3>
                <p className="text-gray-400 text-xs mb-3">
                  Odaberi koji tlocrt se prikazuje kada otvoriš aplikaciju.
                </p>
                <div className="flex gap-2">
                  <button
                    onClick={() => handleFloorChange("inside")}
                    className={`flex-1 py-2 rounded-lg text-xs font-semibold border ${
                      defaultFloor === "inside"
                        ? "bg-[#c1b428] text-black border-[#c1b428]"
                        : "bg-gray-700 text-[#c1b428] border-gray-600"
                    }`}
                  >
                    🏠 Unutarnji
                  </button>
                  <button
                    onClick={() => handleFloorChange("outside")}
                    className={`flex-1 py-2 rounded-lg text-xs font-semibold border ${
                      defaultFloor === "outside"
                        ? "bg-[#c1b428] text-black border-[#c1b428]"
                        : "bg-gray-700 text-[#c1b428] border-gray-600"
                    }`}
                  >
                    🌿 Vanjski
                  </button>
                </div>
                <p className="text-gray-500 text-xs mt-2">
                  Trenutno: <span className="text-[#c1b428]">
                    {defaultFloor === "inside" ? "🏠 Unutarnji" : "🌿 Vanjski"}
                  </span>
                </p>
              </div>

              {/* Placeholder za buduće postavke */}
              <div className="bg-gray-800 rounded-lg p-3 opacity-50">
                <h3 className="text-gray-400 text-xs font-semibold mb-1">Jezik sučelja</h3>
                <p className="text-gray-500 text-xs">Dolazi uskoro...</p>
              </div>

              <div className="bg-gray-800 rounded-lg p-3 opacity-50">
                <h3 className="text-gray-400 text-xs font-semibold mb-1">Notifikacije</h3>
                <p className="text-gray-500 text-xs">Dolazi uskoro...</p>
              </div>

            </div>
          )}

          {activeTab === "logs" && (
            <div>
              {logsLoading ? (
                <p className="text-center text-gray-400 py-8 text-sm">Učitavam logove...</p>
              ) : logs.length > 0 ? (
                <div className="space-y-1">
                  {logs.map((log, i) => (
                    <div key={i} className="bg-gray-800 rounded-lg px-3 py-2 text-xs">
                      <div className="flex justify-between items-center">
                        <span className="text-[#c1b428] font-semibold">{log.user}</span>
                        <span className="text-gray-500">{log.timestamp}</span>
                      </div>
                      <div className="text-gray-300 mt-0.5">{log.description}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-gray-400 py-8 text-sm">Nema logova.</p>
              )}
            </div>
          )}
        </div>

        <div className="p-3 border-t border-[#c1b428] flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-1.5 bg-gray-700 text-[#c1b428] rounded hover:bg-gray-600 text-xs font-semibold"
          >
            Zatvori
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;